export default __webpack_public_path__ + "static/media/lime.1ebea9ba.svg";